import { render } from "./LbrxKioskHeader.vue?vue&type=template&id=24dd893c&scoped=true"
import script from "./LbrxKioskHeader.vue?vue&type=script&lang=js"
export * from "./LbrxKioskHeader.vue?vue&type=script&lang=js"

import "./LbrxKioskHeader.vue?vue&type=style&index=0&id=24dd893c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24dd893c"]])

export default __exports__